import { AlignmentType, Paragraph, TextRun } from "docx";

export const auditPoint1Network = new Paragraph({
    indent: { left: 600, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Perform Vulnerability Assessment and Penetration Testing.",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint2Network = new Paragraph({
    indent: { left: 600, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Identify vulnerabilities in the Internal Network.",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export const auditPoint3Network = new Paragraph({
    indent: { left: 600, },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Recommend solutions to mitigate the identified vulnerabilities and help in improving security of the Internal network.",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false,
        })
    ]
})

export function timeline1Network(startDateString, endDateString) {
    const startDate = new Date(startDateString);
    const endDate = new Date(endDateString);

    function getOrdinalSuffix(day) {
        if (day > 3 && day < 21) return 'th';
        else {
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        }
    }

    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    // Formatting start date
    const formattedStartDate = `${startDate.getDate()}`;
    const startOrdinalSuffix = getOrdinalSuffix(startDate.getDate());
    const startMonth = monthNames[startDate.getMonth()];
    const startYear = startDate.getFullYear();

    // Formatting end date
    const formattedEndDate = `${endDate.getDate()}`;
    const endOrdinalSuffix = getOrdinalSuffix(endDate.getDate());
    const endMonth = monthNames[endDate.getMonth()];
    const endYear = endDate.getFullYear();

    return new Paragraph({
        indent: { left: 600 },
        spacing: { line: 276 },
        bullet: { level: 0 },
        children: [
            new TextRun({
                text: "The Stage 1 Security Audit was executed from ",
                size: 24,
                font: "Arial",
                bullet: { level: 0 },
                color: '000000',
                italics: false,
                bold: false,
            }),
            // Start date part
            new TextRun({
                text: formattedStartDate,
                font: "Arial",
                size: 24,
                color: '000000',
                italics: false,
                bold: false
            }),
            new TextRun({
                text: startOrdinalSuffix,
                superScript: true,
                font: "Arial",
                size: 24,
                color: '000000',
                italics: false,
                bold: false
            }),
            new TextRun({
                text: ' ' + startMonth + ' ' + startYear + ' to ',
                font: "Arial",
                size: 24,
                color: '000000',
                italics: false,
                bold: false
            }),
            // End date part
            new TextRun({
                text: formattedEndDate,
                font: "Arial",
                size: 24,
                color: '000000',
                italics: false,
                bold: false
            }),
            new TextRun({
                text: endOrdinalSuffix,
                superScript: true,
                font: "Arial",
                size: 24,
                color: '000000',
                italics: false,
                bold: false
            }),
            new TextRun({
                text: ' ' + endMonth + ' ' + endYear,
                font: "Arial",
                size: 24,
                color: '000000',
                italics: false,
                bold: false
            })
        ]
    });
}
